import { render, staticRenderFns } from "./AppNotifications.vue?vue&type=template&id=28dede14&scoped=true"
import script from "./AppNotifications.vue?vue&type=script&lang=js"
export * from "./AppNotifications.vue?vue&type=script&lang=js"
import style0 from "./AppNotifications.vue?vue&type=style&index=0&id=28dede14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dede14",
  null
  
)

export default component.exports